export enum MarkerColor {
  Yellow = '#ffff00',
  Red = '#E6213C',
  Green = '#008000'
}
